// src/pages/CourseTime/components/slides/layouts/ContentDescriptionSlide.comp.jsx
import React from 'react';
import * as S from '../../../styles';
import { useSlideContentRenderer } from '../../../hooks/useSlideContentRenderer';

// Layouts: content_description_with_no_image, final_summary
const ContentDescriptionSlide = ({ slide, renderSpokenText, skipTitleSpeech }) => {
  const { renderContent } = useSlideContentRenderer({ renderSpokenText, skipTitleSpeech });

  return (
    <S.SlideDescription>
      <p>{renderContent('content_0', slide.SlideContent)}</p>
    </S.SlideDescription>
  );
};

export default ContentDescriptionSlide;
